import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_MANAGE_BOOKING_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/75555523444/details/23424234755/manage-booking
 */

export class TripManageBookingController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trip.ManageBooking,U,80';
  /**
   * Note that the tripViewId path param is optional since travelers can access the manage booking
   * page for a cancelled booking that does not have an associated trip.
   */
  public readonly path = `${BASEPATH}/trips/:tripViewId([a-z0-z-]+)?/details/:tripItemId([a-z0-z-]+)/manage-booking`;
  public readonly routeName = 'trip-manage-booking';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-manage-booking" */ 'views/trip-manage-booking-view')
  );
  public readonly pageName = 'page.Trip.ManageBooking';
  public readonly clickstreamPageName = 'Trip Manage Booking';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_MANAGE_BOOKING_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trip-manage-booking-controller'
    });

    return Promise.resolve();
  }
}
